import React from 'react';
import * as S from './styles';
import { ContainerProps } from './types';

/**
 * Basic block element used in many designs.  Supports common customizations such
 * as border-weight, border-radius, padding, etc.
 */
function ForwardedContainer<As extends React.ElementType = 'div'>(
  {
    as,
    borderWeight = 'regular',
    children,
    cornerRadius = 3,
    gutter = 3,
    ...props
  }: ContainerProps<As>,
  ref: React.ForwardedRef<React.ElementRef<As>>,
): React.ReactElement | null {
  const Component: React.ElementType = as ?? 'div';

  return (
    <S.Root
      as={Component}
      $borderWeight={borderWeight}
      $cornerRadius={cornerRadius}
      $gutter={gutter}
      ref={ref}
      {...props}
    >
      {children}
    </S.Root>
  );
}

export const Container = React.forwardRef(ForwardedContainer) as <
  As extends React.ElementType = 'div',
>(
  props: ContainerProps<As> & { ref?: React.Ref<React.ElementRef<As>> },
) => React.ReactElement | null;

export default Container;
